import React from 'react';
import { CUPET_STATUS_LABEL, CupetAllocationStatus } from '@tucupet/shared';

const STATUS_COLORS: Record<number, { bg: string; fg: string }> = {
  [CupetAllocationStatus.INSERTED]: { bg: 'var(--surface-2)', fg: 'var(--text-3)' },
  [CupetAllocationStatus.IN_PROCESS]: {
    bg: 'color-mix(in oklab, oklch(0.78 0.16 70) 14%, transparent)',
    fg: 'oklch(0.78 0.16 70)',
  },
  [CupetAllocationStatus.PROVISIONED]: { bg: 'color-mix(in oklab, var(--accent) 14%, transparent)', fg: 'var(--accent)' },
  [CupetAllocationStatus.CANCELLED]: { bg: 'color-mix(in oklab, var(--danger) 14%, transparent)', fg: 'var(--danger)' },
};

export function StatusBadge({ status }: { status: number }) {
  const c = STATUS_COLORS[status] ?? STATUS_COLORS[CupetAllocationStatus.INSERTED]!;
  return (
    <span className="mono" style={{ fontSize: 11, padding: '3px 8px', borderRadius: 999, background: c.bg, color: c.fg, letterSpacing: '0.06em' }}>
      {(CUPET_STATUS_LABEL[status] ?? String(status)).toUpperCase()}
    </span>
  );
}

/** Visual "remaining / assigned" bar with consumed liters. */
export function ConsumptionBar({ amount, realAmount }: { amount: number; realAmount: number }) {
  const consumed = Math.max(0, amount - realAmount);
  const pct = amount > 0 ? Math.min(100, Math.max(0, (consumed / amount) * 100)) : 0;
  return (
    <div style={{ minWidth: 160 }}>
      <div style={{ height: 8, borderRadius: 999, background: 'var(--surface-2)', overflow: 'hidden', border: '1px solid var(--border)' }}>
        <div style={{ width: `${pct}%`, height: '100%', background: 'var(--accent)' }} />
      </div>
      <div className="mono" style={{ fontSize: 10, color: 'var(--text-3)', marginTop: 4 }}>
        {realAmount.toLocaleString('es-MX')} L de {amount.toLocaleString('es-MX')} L · {consumed.toLocaleString('es-MX')} L consumidos
      </div>
    </div>
  );
}
